import React, { Component } from 'react';

import { StringUtils, DateUtils } from '../utils';
import { Routes as routes } from '../navigation';
import { Button } from '../components';
import '../css/SignIn.css';

class AppointmentIcon extends Component {

  constructor(props) {
    super(props);
    this.state = {

    }
  }

  renderAppointmentIcon = (appointment) => {
    if (!appointment || !appointment.time) {
      return null
    }

    let apt_month = appointment.time && DateUtils.getShortMonth(appointment.time) ? DateUtils.getShortMonth(appointment.time) : 'Jan';
    let apt_date  = appointment.time && DateUtils.getDateNumber(appointment.time) ? DateUtils.getDateNumber(appointment.time) : '00';
    let hour      = appointment.time ?  DateUtils.getHoursString(appointment.time)   : '00';
    let minutes   = appointment.time ?  DateUtils.getMinutesString(appointment.time) : '00';
    let ampm      = appointment.time ?  DateUtils.getAMPMString(appointment.time)    : 'AM';
    let day       = appointment.time ?  DateUtils.getLongWeekday(appointment.time)   : 'Weekday';

    return <div style={{ ...this.props.style, display: 'flex', flexDirection: 'row', width: 135, padding: 10, backgroundColor: 'white' }}>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>

          <div style={{ display: 'flex', flexDirection: 'column', margin: 0, width: 50, height: 52, borderRadius: 10, overflow: 'hidden' }}>
            <span style={{ backgroundColor: 'red', color: 'white', fontWeight: 'bold', fontSize: 13, textAlign: 'center', paddingBottom: 2, paddingTop: 2 }}>{ apt_month }</span>
            <span style={{ textAlign: 'center', fontSize: 18, borderStyle: 'solid', borderWidth: 2, borderTopWidth: 0, borderColor: '#e7e7e7', borderBottomLeftRadius: 10, borderBottomRightRadius: 10 }}>{ apt_date }</span>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 10, width: 75 }}>
            <span style={{ fontSize: 18, fontWeight: 'bold' }}>{ day }</span>
            <span style={{ fontSize: 16, color: '#1dc2ff' }}>{ hour + ':' + minutes + ' ' + ampm }</span>
          </div>

        </div>
    </div>
  }

  renderAppointmentIconSmall = (appointment) => {
    if (!appointment || !appointment.time) {
      return null
    }

    let apt_month = appointment.time && DateUtils.getShortMonth(appointment.time) ? DateUtils.getShortMonth(appointment.time) : 'Jan';
    let apt_date  = appointment.time && DateUtils.getDateNumber(appointment.time) ? DateUtils.getDateNumber(appointment.time) : '00';
    let hour      = appointment.time ?  DateUtils.getHoursString(appointment.time)   : '00';
    let minutes   = appointment.time ?  DateUtils.getMinutesString(appointment.time) : '00';
    let ampm      = appointment.time ?  DateUtils.getAMPMString(appointment.time)    : 'AM';
    let day       = appointment.time ?  DateUtils.getLongWeekday(appointment.time)   : 'Weekday';

    return <div style={{ ...this.props.style, display: 'flex', flexDirection: 'row', width: 115, backgroundColor: 'white' }}>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>

          <div style={{ display: 'flex', flexDirection: 'column', margin: 0, width: 40, height: 45, borderRadius: 10, overflow: 'hidden' }}>
            <span style={{ backgroundColor: 'red', color: 'white', fontWeight: 'bold', fontSize: 12, textAlign: 'center', paddingBottom: 2, paddingTop: 2 }}>{ apt_month }</span>
            <span style={{ textAlign: 'center', fontSize: 14, borderStyle: 'solid', borderWidth: 2, borderTopWidth: 0, borderColor: '#e7e7e7', borderBottomLeftRadius: 10, borderBottomRightRadius: 10 }}>{ apt_date }</span>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 10, width: 75 }}>
            <span style={{ fontSize: 14, fontWeight: 'bold' }}>{ day }</span>
            <span style={{ fontSize: 13, color: '#1dc2ff' }}>{ hour + ':' + minutes + ' ' + ampm }</span>
          </div>

        </div>
    </div>
  }

  render() {
    let display_small = this.props.small === true ? true : false;
    let appointment   = this.props.appointment || null;

    return display_small ? this.renderAppointmentIconSmall(appointment) : this.renderAppointmentIcon(appointment);
  }
}

export default AppointmentIcon
